var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTtt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.08 17.632 18.815 3H14l8.29 14.632h4.79zm-4.817.92h4.816l-2.422 4.264h-4.79l2.395-4.263zm5.342 9.474H11.053l2.42-4.29H30l-2.395 4.29zm-23.21-.5L2 23.29l8.263-14.632 2.421 4.237-8.29 14.631zm5.868 0 2.421-4.236-2.42-4.264-2.396 4.264 2.395 4.236zm3.21-15.079L11.08 8.184h4.788l2.421 4.263h-4.816zM30 22.816l-2.132-3.763-2.131 3.763H30zm-8.526-4.71-2.395 4.236-2.422-4.237 2.42-4.263 2.396 4.263zm-10.421.447 2.42 4.263h4.817l-2.422-4.263h-4.815zm0-.921 2.42-4.264h4.79l-2.395 4.264h-4.815zM5.184 28.026h4.29l-2.132-3.79-2.158 3.79zm5.869-20.763 2.157-3.79 2.132 3.79h-4.29z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtt);
export default __webpack_public_path__ + "static/media/TTT.b29f0643160f7a69778533c40ef585f3.svg";
export { ForwardRef as ReactComponent };